import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84da8a82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = ["src"]

import StreetViewPng from '@/assets/street-view.png';
import SatelliteViewPng from '@/assets/satellite-view.png';
import { Map } from 'mapbox-gl';
import { ref } from 'vue';

export type MapViewType = 'street' | 'satellite';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseMapControls',
  props: {
    map: null
  },
  setup(__props: any) {

const props = __props as { map: Map }


const currentView = ref<MapViewType>('street');

const changeBaseLayer = (layer: MapViewType) => {
  switch (layer) {
    case 'satellite':
      props.map.addLayer(
        {
          id: 'satellite-view-layer',
          source: 'satellite-view',
          type: 'raster',
        },
        'street-view-layer'
      );
      props.map.removeLayer('street-view-layer');
      currentView.value = 'satellite';
      break;
    case 'street':
      props.map.addLayer(
        {
          id: 'street-view-layer',
          source: 'street-view',
          type: 'raster',
        },
        'satellite-view-layer'
      );
      props.map.removeLayer('satellite-view-layer');
      currentView.value = 'street';
      break;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_VTooltip = _resolveComponent("VTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VTooltip, {
      text: currentView.value === 'street' ? 'Satellite View' : 'Street View',
      location: "left"
    }, {
      activator: _withCtx(({ props }) => [
        _createElementVNode("button", _mergeProps(props, {
          class: "viewBtn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeBaseLayer(currentView.value === 'street' ? 'satellite' : 'street')))
        }), [
          _createElementVNode("img", {
            class: "rounded",
            src: currentView.value === 'street' ? _unref(SatelliteViewPng) : _unref(StreetViewPng)
          }, null, 8, _hoisted_2)
        ], 16)
      ]),
      _: 1
    }, 8, ["text"])
  ]))
}
}

})